import { ComponentProps } from 'react';
import { Typography } from '../typography/typography';
import { twMerge } from 'tailwind-merge';
import { Breadcrumb as AriaBreadcrumb, Link } from 'react-aria-components';

export type BreadcrumbProps = {
  text: string;
  href: string;
  className?: string;
} & Omit<ComponentProps<typeof AriaBreadcrumb>, 'className'>;

export function Breadcrumb(props: BreadcrumbProps) {
  const { href, text, className, ...rest } = props;

  return (
    <AriaBreadcrumb
      className={twMerge(
        'text-primaryMain data-[current="true"]:text-grayscale300',
        className,
      )}
      {...rest}
    >
      {({ isCurrent }) => (
        <Link href={href} className="flex flex-row items-center space-x-12">
          <Typography variant="body-xxs" weight="regular">
            {text}
          </Typography>
          {!isCurrent && (
            <div
              className="min-w-4 h-4 w-4 bg-grayscale200 rounded-full"
              aria-hidden="true"
            />
          )}
        </Link>
      )}
    </AriaBreadcrumb>
  );
}
